import firebase from "firebase";

// firebase config
var firebaseConfig = {
  apiKey: "AIzaSyAA9JSMlpHdnSnau580T9bW7X0i3PHcK-w",
  authDomain: "naturerleben-dev.firebaseapp.com",
  databaseURL: "https://naturerleben-dev.firebaseio.com",
  projectId: "naturerleben-dev",
  storageBucket: "naturerleben-dev.appspot.com",
  messagingSenderId: "1005284250526",
  appId: "1:1005284250526:web:98ace12a49af0d94f43c8f"
};

firebase.initializeApp(firebaseConfig);

const db =  firebase.firestore();

export default db
